export enum ExerciseListType {
    Subject = 1,
    Extra = 2
}
